/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingStateDto } from '../../models/onboarding-state-dto';

export interface OnboardingStatesGet$Plain$Params {
  organizationId?: string;
  userId?: string;
}

export function onboardingStatesGet$Plain(http: HttpClient, rootUrl: string, params?: OnboardingStatesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardingStateDto>>> {
  const rb = new RequestBuilder(rootUrl, onboardingStatesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('organizationId', params.organizationId, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OnboardingStateDto>>;
    })
  );
}

onboardingStatesGet$Plain.PATH = '/onboarding/states';
